export default "__VITE_ASSET__DnIjeLGc__"